<template>
  <div id="photo-file-upload">
    <file-pond
        name="filepond"
        ref="pond"
        label-idle="Click or Drop files here..."
        allow-multiple="true"
        allow-drop="true"
        accepted-file-types="image/jpeg, image/png"
        :server="{ process, revert,  restore, load, fetch }"
        :init="handleFilePondInit"
        :warning="handleWarning"
        :error="handleError"
        :addfile="handleFileAdded"
        :processfilestart="handleFileProcessStart"
        :processfileprogress="handleFileProcessProgress"
        :processfileabort="handleFileProcessAbort"
        :processfileundo="handleFileProcessUndo"
        :processfile="handleFileProcess"
        :onremovefile="handleFileRemoved"/>
  </div>
</template>

<script>
// More config for FilePond
// https://pqina.nl/filepond/docs/patterns/plugins/introduction/

// Import Vue FilePond
import vueFilePond from "vue-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import file type validation plugin
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js";

// Import ImagePreview
import FilePondPluginImagePreview from "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType
  // FilePondPluginImagePreview
);

import AlbumsRepository from "../repositories/AlbumsRepository";
// FOnt para o website omnes-pro
export default {
  name: "PhotoFileUpload",
  components: {
    FilePond
  },
  props: {
    albumId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      files: [],
      errorLabel: '',
    };
  },

  computed: {
    currentAlbumId() {
      return this.albumId;
    },

    errorMessage() {
      return this.errorLabel
    }
  },
  watch: {},
  methods: {
    handleFilePondInit() {
      console.log("FilePond has initialized");
      // this.$refs.pond.getFiles();
    },

    process(fieldName, file, metadata, load, error, progress, abort) {
      console.log("process start");
      if (this.files.includes(file.name)) {
        error("File already exists ", file.name);
        return 0;
      }

      this.files.push(file.name)
      var self = this;
      try {
        AlbumsRepository.uploadPhotoToAlbum(
          this.albumId,
          file,
          metadata,
          progressCallback => {
            progress(true, progressCallback, 100);
            console.log("Progress ", progressCallback);
          },
          status => {
            // console.log("Status ", status);
          },
          url => {
            load(url);

            console.log("Upload complete at ", url);
          },
          errorCallback => {
            self.handleError(errorCallback);
            console.log("Upload error ", errorCallback);
          }
        );
        return {
          abort: () => {
            abort();
            // uploadTask.cancel();
          }
        };
      } catch (e) {
        this.handleError(error, e);
        console.log("Catched error ", e);
        return {
          abort: () => {
            abort();
          }
        };
      }
    },

    load(uniqueFileId, load, error) {
      // error();
    },

    fetch(url, load, error, progress, abort, headers) {
      error("Local files only");
    },

    restore(uniqueFileId, load, error, progress, abort, headers) {
      // error();
    },

    revert(uniqueFileId, load, error) {
      // TODO -> AlbumRepository delete photo
      // load();
    },

    // func (error[, file, status])
    handleWarning(error) {
      console.log("Warning file ", file);
    },

    // func (error[, file, status])
    handleError(error, e) {
      console.log("Catch error ", e.message);
      switch (e.code) {
        case "storage/canceled":
          break;
        default:
          error(e.message);
      }
    },

    handleAddFileStart(file) {
      console.log("File add start ", file);
    },

    handleFileProcessStart(file) {
      console.log("Processing file start ", file);
    },

    handleFileProcessProgress(file, progress) {
      console.log("Processing file ", file);
      console.log("Processing file progress ", progress);
    },

    handleFileAdded(error, file) {
      if (error) {
        console.log("Error");
        return;
      }
      console.log("File added", file);
    },

    handleFileProcessAbort(file) {
      console.log("Abort Processing file ", file);
    },

    handleFileProcessUndo(file) {
      console.log("Undo Processing file ", file);
    },

    handleFileProcess(error, file) {
      console.log("Processing file ", file);
    },

    handleFileRemoved(file) {
      console.log("Removed file ", file);
      this.files.delete(file.name)
    }
  }
};

// FilePond.setOptions({
//   server: {
//         // disable fetch by explicitely setting it to null,
//         // if not set to null, FilePond will try to automatically
//         // call the ?fetch= and ?load= endpoints
//         fetch: null,
//         load: null,
//         restore: null,
//         revert: null,

//         // define custom process method
//         process: (fieldName, file, metadata, load, error, progress, abort) => {

//             // Create data object containing the file and the file metadata
//             const formData = new FormData();
//             formData.append(fieldName, file, file.name);
//             formData.append(fieldName, JSON.stringify(metadata));

//             // Progress indicator supported, set progress to 25% of 1
//             progress(true, .25, 1);

//             // progress(false); // for infinite upload mode

//             // Fake completion after 1 second
//             const timer = setTimeout(() => {
//                 load('unique-file-id'); // or { body: 'unique-file-id' }
//             }, 1000);

//             // Should expose an abort method so the request can be cancelled by the user
//             return {
//                 abort: () => {

//                     // abort your request here (we clear timer for demo purposes)
//                     clearTimeout(timer);

//                     // updates FilePond interface
//                     abort();
//                 }
//             };
//         },
//     }
// })
</script>

<style scopped>
.filepond--root {
    max-height: 15em;
}
</style>



// WEBPACK FOOTER //
// src/components/PhotoFileUpload.vue